<template>
  <div class="create-rename">
    <van-nav-bar
      class="file-header nav-bar-bgcolor"
      :title="title"
      :left-text="$t('base.cancel')"
      @click-left="handleClose"
      @click-right="handleConfirm"
    >
      <span :class="['btn btn-text', saveDisabled && 'disabled']" slot="right">{{rightText}}</span>
    </van-nav-bar>
    <div class="input-section">
      <div class="thumb-icon">
        <svg-icon :icon="typeIcon" />
      </div>
      <van-field
        ref="field"
        v-model="newName"
        :placeholder="placeholder"
        spellcheck="false"
        maxlength="222"
        clearable
        autofocus
      />
    </div>
  </div>
</template>
<script>
import {i18n} from '@/utils/i18n'
import {pureName} from '@/utils/fileUtils'
import fileActions from '@/utils/fileActions'

const titles = {
  rename: i18n.t('file.action.rename'),
  create: i18n.t('file.create.folder')
}
const confirmBtns = {
  rename: i18n.t('base.save'),
  create: i18n.t('file.create')
}
export default {
  name: 'CreateRename',
  i18n,
  props: {
    actionName: String,
    actionItem: Object,
    headerItem: Object,
    show: Boolean
  },
  data () {
    return {
      newName: this.actionItem ? pureName(this.actionItem.name, this.actionItem.extension) : ''
    }
  },
  computed: {
    saveDisabled () {
      return !this.newName.trim().length
    },
    title () {
      return titles[this.actionName]
    },
    rightText () {
      return confirmBtns[this.actionName]
    },
    typeIcon () {
      const { isDepartment, type_icon } = this.headerItem
      let typeIcon
      if (this.actionName === 'create') {
        typeIcon = isDepartment ? 'collab-folder' : type_icon
      } else if (this.actionName === 'rename' && this.actionItem.type_icon) {
        typeIcon = this.actionItem.type_icon
      }
      return typeIcon || 'folder'
    },
    placeholder () {
      if (this.actionName === 'create') {
        return i18n.t('file.folder.name')
      } else {
        return this.actionItem.type === 'folder' ? i18n.t('file.folder.name') : i18n.t('file.file.name')
      }
    }
  },
  watch: {
  },
  mounted () {
    if (this.actionName === 'rename') {
      this.$refs.field.$refs.input.select()
    }
  },
  methods: {
    handleClose () {
      this.$emit('close-create-rename')
    },
    handleConfirm () {
      if (!this.newName.trim()) {
        return
      }

      if (this.actionName === 'rename') {
        const { typed_id, extension } = this.actionItem
        const newName = this.newName.trim() + (extension ? '.' + extension : '')
        const data = {
          item_typed_id: typed_id,
          name: newName
        }

        fileActions.handleRename(data).then(res => {
          if (res && res.success) {
            this.setState({actionState: {
              action: 'rename',
              type: res.item.type,
              id: res.item.id,
              name: res.item.name
            }})
            this.handleClose()
          }
        })
      } else {
        const { isDepartment, id } = this.headerItem
        const newName = this.newName.trim()
        const data = {
          parent_folder_id: 0,
          name: newName
        }

        if (isDepartment) {
          data.department_id = id
        } else if (id) {
          data.parent_folder_id = id
        }

        fileActions.handleCreate(data).then(res => {
          if (res && res.item) {
            if (this.selectListStack.length) {
              // spaceInfo: 存储当前目录位置，供文件列表判断复制生成项是否要插入列表中
              res.item.spaceInfo = this.selectListPeek
              // createOnFileSelect: flag for enter new folder immediately after create on FileSelect component
              res.item.createOnFileSelect = true
            }
            this.setState({newFolder: res.item})
            if (this.$route.params.module === 'select_destination') {
              // 开放平台选择目标目录时 新建文件夹的跳转会放到
              const {params: {module}} = this.$route
              this.$router.push({ params: { module, space: 'folder', id: res.item.id } })
            }
            this.handleClose()
          }
        })
      }
    }
  }
}
</script>
<style lang="postcss">
@import 'variables';

.create-rename {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 100;
  background-color: #eeeff5;

  & .input-section {
    display: flex;
    margin-top: 18px;
    background-color: #fff
  }

  & .thumb-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 0 0 55px;

    & svg {
      width: 30px;
      height: 30px;
    }
  }

  & .van-field {
    flex: 1 1 auto;
    padding-left: 0;
    padding-right: 0;

    & input {
      flex: 1 1 auto;
    }

    & .van-field__clear {
      flex: 0 0 auto;
      margin-right: 0;
    }
  }
}
</style>
